import { useTranslator } from '@i18n';
import { useTitle } from '@state/titleContext';
import { useEffect } from 'react';

export default function TitleUpdater() {
  const title = useTitle();
  const t = useTranslator();

  useEffect(() => {
    const fullTitle = [t('title'), title].filter(Boolean).join(' - ');
    document.title = fullTitle ?? '';
  }, [title, t]);

  return null;
}
